
import React, { useEffect, useState } from 'react';
import '../scss/header.scss'
function Header(props) {

    const [hash, setHash] = useState('')

    useEffect(() => {
        setHash(window.location.hash);
    }, [hash])


    return (
        <header>
            <div className="container">
                <img src={require('../imgs/logo.png')} alt="" />

                <div className="menu">
                    <a href="#/" className={`menu-item ${hash == '#/' ? 'red' : ''}`}>首页</a>
                    <a href="#/business" className={`menu-item ${hash == '#/business' ? 'red' : ''}`} >商务案例 </a>
                    <a href="#/zp" className={`menu-item ${hash == '#/zp' ? 'red' : ''}`}>作品</a>
                    <a href="#/about" className={`menu-item ${hash == '#/about' ? 'red' : ''}`}>关于我们</a>
                    <a href="#/lx" className={`menu-item ${hash == '#/lx' ? 'red' : ''}`}>联系我们</a>
                </div>
            </div>
        </header>
    )
}


export default Header